import { render, staticRenderFns } from "./IconCheck.vue?vue&type=template&id=04a8614c&scoped=true"
import script from "./IconCheck.vue?vue&type=script&lang=js"
export * from "./IconCheck.vue?vue&type=script&lang=js"
import style0 from "./IconCheck.vue?vue&type=style&index=0&id=04a8614c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a8614c",
  null
  
)

export default component.exports